import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class MemberDataService {
	public constructor(
		private api: ApiService
	) {}

	// CRUD
	public list = () => this.api.sendApiRequest('get', 'member/datatables').toPromise();
	public create = (data: any) => this.api.sendApiRequest('post', 'member', data).toPromise();
	public view = (id: string|number) => this.api.sendApiRequest('get', `member/${id}`).toPromise();
	public edit = (id: string|number, data: any) => this.api.sendApiRequest('put', `member/${id}`, data).toPromise();
	public renew = (id: string|number,data: any) => this.api.sendApiRequest('post', `member/${id}/renew`,data).toPromise();
	public delete = (id: string|number) => this.api.sendApiRequest('delete', `member/${id}`).toPromise();
	public matchrenew = (id: string|number,YFSID: string) => this.api.sendApiRequest('post', `member/${id}/${YFSID}/matchrenew`).toPromise();
	public matchasnew = (id: string|number) => this.api.sendApiRequest('post', `member/${id}/matchasnew`).toPromise();
	public matchdelete = (id: string|number) => this.api.sendApiRequest('post', `member/${id}/matchdelete`).toPromise();
	public participationdelete = (id: string|number) => this.api.sendApiRequest('post', `member/${id}/participationdelete`).toPromise();
}


// WEBPACK FOOTER //
// ./src/services/data.members.service.ts